import { render, staticRenderFns } from "./Fields.vue?vue&type=template&id=4ae512ec"
import script from "./Fields.vue?vue&type=script&lang=ts"
export * from "./Fields.vue?vue&type=script&lang=ts"
import style0 from "./Fields.vue?vue&type=style&index=0&id=4ae512ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports